import { useForm } from "react-hook-form";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, TextField } from "@material-ui/core";
import { basic, validationMessages, requiredOnlyMessage } from '../../../config/validations';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { getViews } from '../../../store/views/selectors';
import { setCurrentViewId, invokePostService, handleSnackBar, setReRender } from '../../../store/global/actions';
import { useHistory } from 'react-router-dom';
import { getDetailsFromUrl } from '../../../services/blueprint';

const CloneView = ({ onClose }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const selectedView = useSelector(getViews);
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, reset, errors, setError } = useForm();

    const { blueprintId, entityId, slug } = getDetailsFromUrl();


    const name = `${selectedView.name}_copy`;
    const description = selectedView.desc;

    useEffect(() => {
        reset({ name, description });
        return () => {
            reset({ name, description });
        };
    }, []);

    const messages = {
        ...validationMessages,
        ...requiredOnlyMessage,
    }


    const onSave = async (data) => {
        setLoading(true);
    
        try {
            const response = await dispatch(invokePostService('cloneView', {name: data.name, desc: data.description, isClone: true}, [selectedView._id]));
    
            if (response.status) {
                dispatch(handleSnackBar({ open: true, message: 'View cloned' }));
                dispatch(setCurrentViewId(response.data._id));
                history.push(`/blueprint/${slug}/${blueprintId}/view/${response.data._id}`);
                dispatch(setReRender());
                onClose();
            } else {
                const error = response.errors?.[0];  
                if (error) setError(error.name, { message: error.message });
            }
        } catch (error) {
            console.error("Error when cloning view:", error);
        } finally {
            setLoading(false);
        }
    };
    
    

    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    InputLabelProps={{
                        shrink: true,
                    }}
                    autoFocus
                    size="small"
                    name="name"
                    fullWidth
                    type={"string"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                    inputRef={register({ ...basic })}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    id="description"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    error={Boolean(errors?.description)}
                    type={"text"}
                    fullWidth
                    rows={4}
                    multiline={true}
                    label={"Description"}
                    placeholder={"Description"}
                    variant="outlined"
                    name="description"
                    helperText={errors?.description ? 'Description is required' : ''}
                    inputRef={register()}

                />
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel onUpdate={handleSubmit(onSave)} updateDisable={loading} onCancel={onClose} content={loading ? 'Cloning..' : 'Clone'} />
            </Grid>
        </Grid>
    )

}

export default CloneView;